import { ProfileOverlay } from "@kosmod/sesame"
import { Component, h, useEffect, useRef, useState } from "@lukekaalim/act"
import { html } from "@lukekaalim/act-web"
import { ConciergeState } from "../hooks/useConciergeState"
import { renderBeat } from "@kosmod/graphics-3d"
import { ID, useJeffect, useLogger } from "@kosmod/kit"

import classes from './ConciergeOverlay.module.css';


import * as three from 'three';
import { RoomSessionChannel } from "../backend"
import { Channel, RTC } from "@kosmod/pancake"
import { createVoiceSessionClient } from "../backend/voiceSession"
import { ProfileCircle } from "@kosmod/sesame"

export type ConciergeOverlayProps = {
  state: ConciergeState,

  port: Channel.Port.Client<RoomSessionChannel>,
  rtcClient: RTC.Client,
}

export const ConciergeOverlay: Component<ConciergeOverlayProps> = ({ state, port, rtcClient }) => {
  const profileCircleRef = useRef<HTMLElement | null>(null);
  const volumeVisRef = useRef<HTMLElement | null>(null);
  const freqVisRef = useRef<HTMLElement | null>(null);
  const [analyzer, setAnalyser] = useState<AnalyserNode | null>(null)

  const logger = useLogger('ConciergeOverlay');

  const onClickJoinVC = async () => {
    const setup = state.audio.getOrCreateSetup();
    const ctx = setup.context;
    const dest = setup.dest;

    const vcLogger = logger.createSubsystem('voice')

    const mic = await navigator.mediaDevices.getUserMedia({ audio: {
      sampleRate: 48000,
      channelCount: 2,
      echoCancellation: false,
      noiseSuppression: true,
      autoGainControl: true,
    } });
    const source = ctx.createMediaStreamSource(mic);
    

    // const proc = new DeepFilterNet3Core({
    //   sampleRate: 48000,
    //   noiseReductionLevel: 80,
    //   //enabled: true,
    //   assetConfig: {
    //     cdnUrl: 'http://localhost:5173/noise',
    //     version: '2'
    //   }
    // });

    // await proc.initialize();
    // const noiseFilter = await proc.createAudioWorkletNode(ctx);
    const filter = ctx.createBiquadFilter();
    filter.type = 'bandpass';
    filter.frequency.value = 400;
    filter.Q.value = 10;

    state.audio.localVoiceStream.set(mic);
    state.audio.localVoiceNode.set(source);

    const analyzer = ctx.createAnalyser();
    setAnalyser(analyzer);

    //source.connect(dest);
    source.connect(filter);
    filter.connect(analyzer);


    vcLogger.log(`On click join vc`, otherPlayers)
    
    state.roomClient.voice.subjects.offers.subscribe(async o => {
      vcLogger.log(`GOT AN OFFER`, o)
      const message = o.message;
      if (message.type !== 'offer')
        throw new Error();

      const signal = state.roomClient.voice.createSignalingChannel(o.source);
      const peer = await rtcClient.createPeerFromOffer(signal, message);
      vcLogger.log(`GOT A REMOTE PEER`, o)
      
      peer.onMedia.subscribe(media => {
        vcLogger.log(`GOT MEDIA`, media)
      })
    })

    for (const player of otherPlayers) {
      const signal = state.roomClient.voice.createSignalingChannel(player.id);
      vcLogger.log(`Creating peer for ${player}`)
      const peer = rtcClient.createPeer(signal);
      
      peer.sendMedia(mic.getAudioTracks()[0])
    }
  };

  useJeffect(j => {
    const circle = profileCircleRef.get()!.children[0] as HTMLElement;
    const volumeVis = volumeVisRef.get()!;
    const frequencyVis = freqVisRef.get()!;
    if (!analyzer)
      return;

    analyzer.fftSize = 1024;
    analyzer.smoothingTimeConstant = .5;
    const data = new Uint8Array(analyzer.frequencyBinCount);
    
    const litColor = new three.Color('#2fa911');
    const unlitColor = new three.Color('#d6d6d6');

    const finalColor = new three.Color();

    j.add(onRender(() => {
      analyzer.getByteFrequencyData(data);
      const sum = data.reduce((a, b) => a + b, 0);
      const highestFreq = {
        index: 0,
        value: 0,
      }
      for (let i = 0; i < data.length; i++) {
        if (data[i] > highestFreq.value) {
          highestFreq.index = i;
          highestFreq.value = data[i];
        }
      }

      const avg = (sum / data.length);
      const val = (avg / 10) * 2;

      finalColor.lerpColors(unlitColor, litColor, Math.max(0, Math.min(1, val > .1 ? 1 : 0)))

      volumeVis.style.height = `${val * 100}px`;
      volumeVis.textContent = val.toFixed(2);
      frequencyVis.style.height = `${(highestFreq.index / data.length) * 100}px`
      frequencyVis.textContent = (highestFreq.index / data.length).toFixed(2);
      circle.style.borderColor = '#' + finalColor.getHexString()

      state.audio.localVoiceVolume.set(val);
    }))
  }, [analyzer])

  const onRender = renderBeat.useBeat();

  const otherPlayers = state.players.filter(p => p.id !== state.self.id);

  return h(ProfileOverlay, { auth: state.auth, account: state.account, beforeCapsule: [
    h(html.div, { style: { position: 'relative', width: '50px' } }, [
      analyzer && h(html.div, { style: { display: 'inline-block', border: '1px dotted black', width: '50px', top: '0px', height: '100px', position: 'absolute' } }),
      h(html.div, {
        ref: volumeVisRef, style: {
          border: '1px solid transparent', display: 'inline-block', background: 'green', width: '50px', top: '0px', position: 'absolute', color: 'white',
          backgroundClip: 'padding-box'
        } }),
    ]),
    h(html.div, { style: { position: 'relative', width: '50px' } }, [
      analyzer && h(html.div, { style: { display: 'inline-block', border: '1px dotted black', width: '50px', top: '0px', height: '100px', position: 'absolute' } }),
      h(html.div, {
        ref: freqVisRef, style: {
          border: '1px solid transparent', display: 'inline-block', background: 'red', width: '50px', top: '0px', position: 'absolute', color: 'white',
          backgroundClip: 'padding-box'
        } }),
    ]),
    h(html.div, { className: classes.overlayBeforeColumn }, [
      h(html.button, { onClick: onClickJoinVC, className: classes.joinVCButton }, 'Mic'),
    ]),

    h(html.div, {}, [
      otherPlayers.map(player => h(ProfileCircle, { name: player.name, colorHash: player.id }))
    ])
  ], profileCircleRef })
}